module.exports = __webpack_public_path__ + "static/media/202102-sc.84eacb8e.jpg";